<template>
  <div class="paper-content-pre">
    <van-loading class="loading-pre" v-if="loading" color="#1989fa" size="24px"
      >loading...</van-loading
    >
    <div
      v-if="speakShow && task.show"
      class="img-content"
      :style="{ height: `${fHeight}px` }"
    >
      <img v-if="task.url !== ''" :src="task.url" alt="" style="width: 100%" />
      <p v-else>未能发现对应的资源！！！</p>
    </div>
    <div class="statistics" id="statistics" ref="paper" v-else>
      <div class="header">
        <div style="text-align: center;">
          <i class="el-icon-collection left-icon"></i>
          <span style="margin-left: 10px">{{ exam.title }}</span>
        </div>
        <div style="text-align: center;">
          （分值：{{ exam.totalScore }}分） 试题数：{{ total }}
        </div>
      </div>

      <div
        id="content1"
        v-if="!speakShow"
        v-html="exam.content"
        class="exam-content"
      ></div>

      <div class="card" v-if="exam.type === '5'">
        <div class="hard">
          <span>答题卡</span>
        </div>
        <div
          id="answerSheet"
          style="margin: 10px 20px;word-wrap:break-word;"
          v-html="exam.answerSheet"
        ></div>
      </div>

      <div v-if="speakShow && !task.show" class="speaking">
        <div id="speaking" class="speaking-content" v-html="exam.content"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { Loading } from "vant";
import { mapQuery } from "../util/URLUtils";
import req from "../util/req";
import {
  handlePauseUtil,
  getInputSortUtil,
  getAudioUtil,
  arraySort,
} from "@/util/preTask";
import insert from "@/util/insertDomPc";
// 给分点内容（作文要求 / 要求附件）按小题注入，逻辑与 PenAndComp.vue 预览共用
import {
  renderFlowExtras as injectFlowExtras,
  isFlowExtraPaperType,
} from "@/util/flowExtra";
export default {
  name: "preview",
  data() {
    return {
      loading: false,
      query: mapQuery(),
      firstData: {},
      open: true,
      exam: {},
      total: 0,
      // content:'',
      answerSheet: "",
      speakShow: false,
      flow: {},
      imgUrl: "",
      task: {
        show: false,
      },
      full: true,
      fHeight: document.documentElement.clientHeight - 100,
    };
  },
  components: {
    [Loading.name]: Loading,
  },
  mounted() {
    this.getExam();
  },
  methods: {
    getExam() {
      let param = { id: this.query.id };
      // isExam=1：考试预览（教师端「考试详情 → 预览试卷」，由小程序 /preTask 页透传），
      // 试卷详情要走考试试卷接口；不传该参数时为作业预览，仍走作业试卷接口。
      // 两个接口返回的试卷结构一致（content / type / flows / answerSheet / totalScore），
      // 后续 init() 流程无需区分。
      const isExam = this.query.isExam == "1";
      const url = isExam ? "/api/exam/testPaper" : "/api/exam/taskPaper";
      this.loading = true;
      req.post(url, param).then((res) => {
        this.loading = false;
        const { data } = res.data;
        this.init(data);
      });
    },
    downloadWord() {
      let html = this.$refs["paper"].outerHTML;
      // const docx = htmlDocx.asBlob(html); // 将HTML内容转换为Word文档的Blob对象
      const docx = new Blob(
        [
          `<!DOCTYPE html><head><meta charset="utf-8"><meta name="viewport" content="width=device-width,initial-scale=1.0"><style  type="text/css"></style ></head > <body>${html}</body></html > `,
        ],
        { type: "application / msword" },
      );
      const url = window.URL.createObjectURL(docx); // 创建一个临时的URL对象
      // 创建一个a标签并设置href属性为生成的URL，以及下载属性为文件名
      const link = document.createElement("a");
      link.href = url;
      link.download = `${this.exam.title}.docx`;
      // 触发点击事件来下载文件
      document.body.appendChild(link);
      link.click();
      // 下载完成后移除临时URL对象和a标签
      window.URL.revokeObjectURL(url);
      document.body.removeChild(link);
    },
    // 处理 v-html 中的 table：与 TaskEvaluation.vue 保持一致
    initTableLayout() {
      // 同时处理 exam-content 和 speaking-content 两个容器
      const containers = [
        document.getElementById("content1"),
        document.getElementById("speaking"),
      ].filter(Boolean);
      containers.forEach((container) => {
        // 处理 table 元素：宽度最大100%，列宽自适应
        const tableList = container.querySelectorAll("table");
        for (let i = 0; i < tableList.length; i++) {
          const tbl = tableList[i];
          tbl.removeAttribute("width");
          // 微信小程序兼容：用 setProperty 设置 !important，确保覆盖 HTML width 属性和 Word 样式
          tbl.style.setProperty("width", "100%", "important");
          tbl.style.setProperty("max-width", "100%", "important");
          // fixed：表格宽度固定为100%，列宽根据首行内容自动分配
          tbl.style.setProperty("table-layout", "fixed", "important");
          tbl.style.setProperty("display", "table", "important");
          // keep-all：保持英语单词完整，仅空格/标点处换行；break-word：单词超宽时才断词
          tbl.style.setProperty("word-break", "keep-all", "important");
          tbl.style.setProperty("overflow-wrap", "break-word", "important");
        }

        // 处理 td/th：移除固定宽度，强制换行
        const tdList = container.querySelectorAll("td, th");
        for (let i = 0; i < tdList.length; i++) {
          const td = tdList[i];
          td.removeAttribute("width");
          td.removeAttribute("nowrap");
          // 清除所有固定宽度（含 pt/px/%），让 table-layout:fixed 自动分配
          td.style.width = "auto";
          td.style.maxWidth = "none";
          // 用 setProperty 设置 !important，确保覆盖 Word 转 HTML 的内联样式
          td.style.setProperty("white-space", "normal", "important");
          // keep-all：保持英语单词完整；break-word：单词超宽时才断词
          td.style.setProperty("word-break", "keep-all", "important");
          td.style.setProperty("word-wrap", "break-word", "important");
          td.style.setProperty("overflow-wrap", "break-word", "important");
          // 清除子元素上的换行限制和固定宽度
          const children = td.querySelectorAll("*");
          for (let j = 0; j < children.length; j++) {
            const child = children[j];
            child.removeAttribute("nowrap");
            child.removeAttribute("width");
            child.style.setProperty("white-space", "normal", "important");
            // keep-all：保持英语单词完整
            child.style.setProperty("word-break", "keep-all", "important");
            child.style.setProperty("word-wrap", "break-word", "important");
            child.style.setProperty("overflow-wrap", "break-word", "important");
            // 清除子元素的固定宽度（pt/px），允许 max-width:100% 限制图片等
            if (
              child.style.width &&
              (child.style.width.includes("pt") ||
                child.style.width.includes("px"))
            ) {
              child.style.width = "";
            }
            // 微信小程序兼容：所有子元素统一限制最大宽度，避免溢出
            child.style.maxWidth = "100%";
          }
        }

        // 移除 col/colgroup 上的宽度限制
        const colList = container.querySelectorAll("col, colgroup");
        for (let i = 0; i < colList.length; i++) {
          colList[i].removeAttribute("width");
          colList[i].style.width = "";
        }

        // 如果第一列的内容只有数字，则第一列设置固定宽度 40px
        const tableListForFirstCol = container.querySelectorAll("table");
        for (let i = 0; i < tableListForFirstCol.length; i++) {
          const tbl = tableListForFirstCol[i];
          const firstRow = tbl.querySelector("tr");
          if (firstRow) {
            const firstCell = firstRow.querySelector("td, th");
            if (firstCell) {
              const text = (firstCell.textContent || "").trim();
              if (text && /^\d+$/.test(text)) {
                // 用 setProperty 设置 !important，确保覆盖 CSS 样式表中的 width:auto !important
                firstCell.style.setProperty("width", "40px", "important");
              }
            }
          }
        }
      });
    },
    init(data, tk = null) {
      if (this.equals(this.firstData, data)) {
        return false;
      } else {
        this.firstData = { ...data };
        this.open = true;
        this.exam = data;
        // this.exam.content = this.exam.content.replace(/<img/g, '<img style="width: 350px"')
        //时间预览去掉小旗子标记
        this.exam.content = this.exam.content.replace(
          /<img[^>]*src="https:\/\/jiongyi-1305135066\.cos\.ap-shanghai\.myqcloud\.com\/20241018105529\.png"[^>]*>/gi,
          "",
        );
        //5个连在一起的图片统一宽度
        this.exam.content = this.exam.content.replace(
          /(<img[^>]*>){5}/g,
          function(match) {
            return match.replace(/<img/g, '<img style="width: 350px"');
          },
        );
        if (tk) this.task = tk;
        this.speakShow = false;
        if (
          data.type === "3" ||
          data.type === "6" ||
          data.type === "10" ||
          data.type === "11"
        )
          this.speakShow = true;
        let mapTag = {};
        this.urls = [];
        const self = this;
        this.exam.flows = this.exam.flows.sort(arraySort("sort"));
        // console.log(this.exam.flows);
        if (this.exam.flows && this.exam.flows.length > 0) {
          this.total = this.exam.flows.length;
          this.exam.flows.forEach((f, index) => {
            mapTag[f.tagId] = f;
            f.urls = [];
            if (f.speakingAttachmentUrl && f.speakingAttachmentUrl !== "") {
              if (f.speakingAttachmentUrl.includes("|")) {
                //type:1,播放，2：停顿，3：准备时间，4：录音时长
                let list = f.speakingAttachmentUrl.split("|");
                list.forEach((u) => {
                  let item = { type: 1, value: 0, src: "" };
                  if (u.indexOf("$") > -1) {
                    item.type = 2;
                    item.value = parseInt(u.substr(1, u.length));
                  } else {
                    item.src = u;
                  }
                  f.urls.push(item);
                });
              } else {
                f.urls.push({
                  type: 1,
                  value: 0,
                  src: f.speakingAttachmentUrl,
                });
              }
            }
            if (f.prepareSeconds && f.prepareSeconds > 0) {
              f.urls.push({ type: 3, value: f.prepareSeconds, src: "" });
            }
            if (f.speakingSeconds && f.speakingSeconds > 0) {
              f.urls.push({ type: 4, value: f.speakingSeconds, src: "" });
            }
          });
        }

        if (this.speakShow && !this.task.show) {
          this.$nextTick(() => {
            this.editorSpeakingContent();
            this.exam.showListening = 1; //预览时，显示听力原文
            getAudioUtil(this.exam);
            // 写作类「作文要求 / 要求附件」按小题注入
            // 必须放在答案回填之前：空位([name=tagId])还在，才能定位到该小题插入
            this.renderFlowExtras();
            // 选择题根据答案默认选中且不可手动点击（含 # 分割的大题小题答案）
            getInputSortUtil(this.exam.flows);
            // v-html 渲染后处理 table 布局（与 TaskEvaluation.vue 一致）
            this.initTableLayout();
          });
        } else {
          setTimeout(() => {
            this.exam.showListening = 1; //预览时，显示听力原文
            getAudioUtil(this.exam);
            // 写作类「作文要求 / 要求附件」按小题注入
            // 必须放在答案回填之前：空位([name=tagId])还在，才能定位到该小题插入
            this.renderFlowExtras();
            getInputSortUtil(this.exam.flows);
            // v-html 渲染后处理 table 布局（与 TaskEvaluation.vue 一致）
            this.initTableLayout();
          }, 100);
        }

        this.$nextTick(() => {
          let audioArr = document.querySelectorAll("audio");
          this.makeOnePlay(audioArr);
        });
      }
    },
    // 判断两个对象是否相等
    equals(obj1, obj2) {
      // 首先判断是否是引用类型
      var f1 = obj1 instanceof Object;
      var f2 = obj2 instanceof Object;
      // 如果有一个不是引用数据类型，那就进行直接判断。（内存地址不同）
      if (!f1 || !f2) {
        return obj1 === obj2;
      }
      // 若全是引用类型的，那就先看一下属性值的长度是否相等，若不相等，就直接false啦。
      if (Object.keys(obj1).length !== Object.keys(obj2).length) {
        return false;
      }
      /**
       * 若属性值的长度相等，就接着遍历里边的每一个属性，还是先看里边的属性是哪一个类型，
       * 如果全是引用类型，那就接着对里边的属性调用equals递归函数。
       * 如果不全是引用类型，那就比较这两个值是否相等，若不相等就直接false啦。
       */
      for (var p in obj1) {
        var a = obj1[p] instanceof Object;
        var b = obj2[p] instanceof Object;
        if (a && b) {
          this.equals(obj1[p], obj2[p]);
        } else if (obj1[p] != obj2[p]) {
          return false;
        }
      }
      return true;
    },
    // 音频只能播放一个
    makeOnePlay(audioArr) {
      for (let i = 0; i < audioArr.length; i++) {
        let audio = audioArr[i];
        audio.addEventListener("play", function(e) {
          for (let j = 0; j < audioArr.length; j++) {
            if (j !== i) {
              audioArr[j].pause();
            }
          }
        });
      }
    },
    editorSpeakingContent() {
      // this.content = this.exam.content;
      const hrList = document.querySelectorAll("hr");
      let flows = this.exam.flows.sort(arraySort("sort"));
      let content1 = document.getElementById("speaking");
      if (hrList.length === 0) {
        content1.append(insert.addAudio(flows[0], true));
        content1.append(insert.addAnswer(flows[0]));
      } else {
        flows.forEach((item, index) => {
          const hr = hrList[index];
          if (hr !== undefined) {
            hr.before(insert.addAudio(item, true));
            hr.before(insert.addAnswer(item));
          }
          if (index === flows.length - 1 && hr === undefined) {
            content1.append(insert.addAudio(item, true));
            content1.append(insert.addAnswer(item));
          }
        });
      }
    },

    changeQuestionContent(value) {
      this.flow = this.exam.flows[value];
    },

    /**
     * 按小题渲染「作文要求」「要求附件」：
     * 内容来自 flows[].scorePointList（详见 util/flowExtra.js），插到该小题空位之前。
     * 容器按 正文 → 听说正文 → 答题卡 依次尝试，同名空位只插第一处。
     * 试卷级门：仅 exam.type 为 4 / 5 的试卷；小题级门：仅 knowledgeType 为 12 的写作小题
     * （knowledgeType 是小题最外层字段，在 util 的 getFlowExtraList 里逐小题判断）。
     */
    renderFlowExtras() {
      const exam = this.exam || {};
      if (!isFlowExtraPaperType(exam.type)) return;
      injectFlowExtras(exam.flows, [
        "content1",
        "speaking",
        "answerSheet",
      ]);
    },

    cancel() {
      handlePauseUtil("content1");
      this.open = false;
      this.firstData = {};
    },

    fullHandle() {
      this.full = !this.full;
      this.fHeight = !this.full
        ? `640`
        : `${document.documentElement.clientHeight - 100}`;
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.page-icon {
  position: absolute;
  right: 60px;
  top: 20px;
  color: #909399;
  cursor: pointer;
}
.paper-content-pre {
  margin: 0 auto;
  position: relative;
  border: 1px solid #cccccc;
  overflow-y: auto;
  height: 100vh;
  width: 100vw;
  overflow-x: hidden;
  .img-content {
    p {
      font-size: 24px;
      font-weight: bold;
      text-align: center;
      letter-spacing: 2px;
      margin-top: 80px;
    }
  }
  .statistics {
    overflow: auto;
    position: relative;
    overflow-x: hidden;
    // height: calc(100vh - 110px);
    .header {
      //   height: 40px;
      padding: 5px 10px;
      color: white;
      font-size: 16px;
      //   display: flex;
      //   align-items: center;
      //   justify-content: space-between;
      background-color: rgba(0, 160, 233, 0.6);
      .left-icon {
        line-height: 40px;
        width: 40px;
        text-align: center;
        background-color: #0a6cd6;
      }
    }
    ::v-deep .exam-content {
      white-space: normal;
      word-break: keep-all;
      overflow-y: auto;
      overflow-x: auto;
      padding: 10px 10px 30px 10px !important;
      // box-sizing: border-box;
      img {
        max-width: calc(100% - 20px) !important;
      }
      img,
      div,
      p,
      span {
        word-wrap: break-word !important;
        width: calc(100% - 20px) !important;
      }
    }
    .exam-content >>> p {
      white-space: normal;
      word-break: keep-all;
    }
    .exam-content >>> span {
      white-space: normal;
      word-break: keep-all;
    }

    .content {
      width: 100%;
      padding: 10px;
    }
    .card {
      margin: 10px;
      border: 1px solid #f3f3f3;
      .hard {
        height: 40px;
        background-color: #f3f3f3;
        span {
          line-height: 40px;
          margin-left: 20px;
        }
      }
    }
    ::v-deep .speaking {
      position: relative;
      .speaking-content {
        white-space: normal;
        word-break: keep-all;
        overflow-y: auto;
        overflow-x: auto;
        width: 100vw;
        padding: 10px 10px 30px 10px !important;
        box-sizing: border-box;
        // padding-left: 10px !important;
        img {
          max-width: calc(100% - 20px) !important;
        }
        div,
        p,
        span {
          word-wrap: break-word !important;
          width: 100% !important;
        }
      }
      .speaking-content >>> p {
        line-height: 32px;
      }
      .speaking-content >>> span {
        line-height: 28px;
      }
    }
  }
  .bottom {
    width: 100%;
    height: 60px;
    margin-top: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #f9f9f9;
    .label {
      font-size: 22px;
      font-weight: 500;
      line-height: 32px;
      text-align: center;
    }
    .two {
      display: flex;
      justify-content: center;
    }
    .three {
      .right-div {
        padding: 1px;
        border-radius: 2px;
        border: 1px dashed #666666;
        .second-div {
          width: 300px;
          margin: 0 2px;
          box-sizing: border-box;
          background-color: white;
        }
      }
    }
  }
}
.export-pdf {
  position: absolute;
  right: 90px;
  top: 16px;
}
.loading-pre {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 999;
}
::v-deep table {
  width: 100% !important; /* 替代 100vw */
  table-layout: fixed; /* 固定列宽分配 */
  border-collapse: collapse; /* 合并边框 */
  word-break: keep-all !important; /* 保持英语单词完整 */
  overflow-wrap: break-word !important; /* 单词超宽时才断词 */
  margin: 0 !important;
  tr {
    width: 100%;
  }
  td,
  th {
    height: auto !important;
    word-break: keep-all !important; /* 保持英语单词完整 */
    word-wrap: break-word !important;
    overflow-wrap: break-word !important;
    white-space: normal !important; /* 允许换行 */
    width: auto !important;
    // min-width: 100px;
    // &:first-of-type {
    //   width: 100px !important;
    // }
    /* 限制 input 宽度最大为所在 td 宽度 - 10px */
    input {
      max-width: calc(100% - 10px) !important;
      box-sizing: border-box !important;
    }
    /* 子元素强制换行 */
    p,
    span,
    div {
      word-break: keep-all !important;
      word-wrap: break-word !important;
      overflow-wrap: break-word !important;
      white-space: normal !important;
    }
  }
  audio,
  img {
    width: 100%;
  }
}

// 「作文要求/要求附件」块：由 renderFlowExtras 注入到正文/答题卡内部。
// 注入节点由 JS 生成、不带 data-v 属性，普通 scoped 规则命中不了，必须用 ::v-deep。
// 与后台 Preview/index.vue 保持同一套样式
::v-deep .essay-requirement {
  margin: 10px 0;
  padding: 8px 12px;
  background-color: #fdf6ec;
  border: 1px solid #faecd8;
  border-radius: 4px;
  .essay-requirement__title {
    font-size: 15px;
    font-weight: 600;
    color: #e6a23c;
    margin-bottom: 8px;
  }
  .essay-requirement__content {
    font-size: 14px;
    color: #303133;
    line-height: 1.6;
    margin-bottom: 12px;
    word-break: break-word;
    overflow-wrap: break-word;
    p {
      margin: 6px 0 !important;
    }
    img {
      max-width: 100%;
      height: auto;
    }
  }
  .essay-requirement__subtitle {
    font-size: 13px;
    font-weight: 600;
    color: #e6a23c;
    margin-bottom: 8px;
  }
  .essay-requirement__img {
    display: block;
    max-width: 100%;
    height: auto;
    border-radius: 4px;
    border: 1px solid #ebeef5;
  }
}
</style>
